import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from '@node_modules/primeng';
import { CommunicationTimelineComponent } from './communication-timeline.component';

@NgModule({
  declarations: [
    CommunicationTimelineComponent
  ],
  imports: [
    CommonModule,
    ProgressSpinnerModule
  ],
  exports: [
    CommunicationTimelineComponent
  ]
})
export class CommunicationTimelineModule { }
